import { render } from "./AddUserMunic.vue?vue&type=template&id=22b49d21&scoped=true"
import script from "./AddUserMunic.vue?vue&type=script&lang=js"
export * from "./AddUserMunic.vue?vue&type=script&lang=js"

import "./AddUserMunic.vue?vue&type=style&index=0&id=22b49d21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b49d21"]])

export default __exports__